module.exports = __webpack_public_path__ + "img/gal-3.a398dbb9.jpg";